export const tooltipFigures = document.querySelectorAll<HTMLElement>('figure[data-tooltip]');

tooltipFigures.forEach(figure => {
    figure.addEventListener('click', (event: Event) => {
        // TODO: To make tooltips mobile-friendly, enable the following code
        //       but also provide a good UX for dismissing tooltip
        // const currentTarget = event.currentTarget as HTMLElement;
        // currentTarget.classList.toggle('active');
    });
});
